export default "/images/message-circle.svg?7796f8f5908baae73ff7967460a4f822";